import type { SchemaTabWithSlotLayout } from '@cli-types/core-engine/schema-reader.js'
import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { isSchemaSlotLayout } from './is-schema-slot-layout.js'
import { normalizeFields } from './normalize-fields.js'
import { normalizeSlotLayoutFields } from './normalize-slot-layout-fields.js'

export function normalizeTabSlotLayout(
  tab: SchemaTabWithSlotLayout
): NonNullable<SchemaField['tabs']>[number] {
  const { slot: _slot, ...rest } = tab

  if (isSchemaSlotLayout(tab.slot)) {
    return {
      ...rest,
      fields: normalizeSlotLayoutFields(tab.slot)
    }
  }

  return {
    ...rest,
    fields: normalizeFields(tab.fields ?? [])
  }
}
